import { getUrlParams } from "./utils";
export function getDefaultPagination(defaultCurrentPage = 1, defaultPageSize = 10) {
    // @ts-expect-error this isn't even being used, only 1 reference in an old page
    const { pageNumber, pageSize } = getUrlParams(["pageNumber", "pageSize"]);
    return {
        current: pageNumber ? +pageNumber : defaultCurrentPage,
        pageSize: pageSize ? +pageSize : defaultPageSize,
    };
}
export function paginationParams(page, pageSize) {
    const skipCount = (page - 1) * pageSize;
    const maxResultCount = pageSize;
    return {
        SkipCount: skipCount,
        MaxResultCount: maxResultCount,
    };
}
export function getInfiniteScrollNextPageParam(lastPage, _allPages) {
    const totalFetched = _allPages.reduce((acc, page) => acc + page.items.length, 0);
    if (totalFetched >= lastPage.totalCount)
        return undefined;
    return totalFetched;
}
